import type {InventoryPlot} from '@/domain/entities/InventoryPlot';
import type {InventoryPlotRepository} from '@/domain/interfaces/InventoryPlotRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {InventoryPLotDto} from './InventoryPLotDto';
import {toDomain, toDto} from './InventoryPLotMappers';

const PATH = 'inventory-plots/';

export class RestInventoryPlotRepository implements InventoryPlotRepository {
  constructor(private readonly httpClient: HttpClient) {}
  list = async (forestMassUuid: string) => {
    const dtos = await this.httpClient.get<Array<InventoryPLotDto>>(`${PATH}?forestMassUuid=${forestMassUuid}`);
    return dtos.map((dto) => toDomain(dto));
  };
  get = async (uuid: string) => {
    const dto = await this.httpClient.get<InventoryPLotDto>(`${PATH}${uuid}`);
    return dto ? toDomain(dto) : undefined;
  };
  patch = async (domain: InventoryPlot): Promise<InventoryPlot> => {
    const dto = await this.httpClient.patch<InventoryPLotDto, InventoryPLotDto>(`${PATH}${domain.uuid}`, toDto(domain));
    return toDomain(dto);
  };

  delete = async (uuid: string) => {
    return this.httpClient.delete(`${PATH}${uuid}`);
  };
}
